import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './components/layout/AppLayout';

import LoginPage     from './pages/LoginPage';
import SignupPage    from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage    from './pages/SearchPage';
import CleanupPage   from './pages/CleanupPage';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"  element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignupPage /></PublicRoute>} />

      <Route path="/" element={
        <PrivateRoute><AppLayout><DashboardPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/search" element={
        <PrivateRoute><AppLayout><SearchPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/cleanup" element={
        <PrivateRoute><AppLayout><CleanupPage /></AppLayout></PrivateRoute>
      }/>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          theme="dark"
          toastStyle={{
            background: 'var(--navy-light)',
            border: '1px solid var(--navy-border)',
            color: 'var(--text-primary)'
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
